// a hard code store slug, for there's special content for UK amazon sup

const amazonUKSlugs = [
    // beta
    "amazon-51405",
    // production
    "amazon-19410",
];

export const isAmazonUKSlug = (storeSlug: string) => {
    return amazonUKSlugs.includes(storeSlug);
};
